/**
 * LayoutsPanel component
 * @constructor editor.mediatabs.LayoutsPanel
 * @param {object} dom DOM
 */
fx.ns("desktop.book.edition", class LayoutsProductPanel extends fx.components.Box
{
    
    constructor(model)
	{
		super(model);

		this.layouts = model.layouts;
        this._book = model.creation;

		this.listenUpdates(model.creation);
		
	}

	get book()
	{
		return this._book;
	}

	set book(val)
	{
		this._book = val;
	}
	
	get currentArea()
	{
		return this._currentArea;
	}

	set currentArea(val)
	{
		this._currentArea = val;

        if (this._currentArea && this._currentArea.data && this.layoutFilter)
		    this.layoutFilter.type = this._currentArea.data.isCover ? "cover" : "page";

        this._updateView();
	}

    get filterChoices()
	{
		if (!this._filterChoices)
			this._filterChoices = [	{label:fx.text("Thématique"), data:"recommended"},  {label:fx.text("Classique"), data:"classical"}];
		
		return this._filterChoices;
	}

	set filterChoices(choices)
	{
		this._filterChoices = choices;
		if(this.numberPhotoSelect)
			this._selectTab(this._filterChoices[0].data);
	}


	create()
	{
		super.create();

		//--------------------- layouts ---------------------//

		this.layoutFilter = new filters.LayoutProductFilter(this.book.product);
        if (this._currentArea && this._currentArea.data)
            this.layoutFilter.type = this._currentArea.data.isCover ? "cover" : "page";
        
		this.numberPhotoSelect = new fx.components.SelectButtons({items : [	{label:"1", value:1}, 
                                                                            {label:"2", value:2}, 
                                                                            {label:"3", value:3}, 
                                                                            {label:"4", value:4}, 
                                                                            {label:"5+", value:"+"} ]});

		this.layoutsGrid = new fx.components.VerticalGridDynamic( { className : "layoutGrid",
																	data : this.layouts,
																	filter : this.layoutFilter,
																	maxElementsPerRow : 2,
																	maxRowHeight : 230,
																	newChildEffect : "fade",
																	renderers : {ThemeLayout : shared.renderers.LayoutRenderer} 
																} );

        if (this.layouts.hasCollectionLayoutsForPage)
        {
            this.choicesSelect = new fx.components.TabBarHorizontal( {tabs : this.filterChoices, style : "underline"} );
            this.choicesSelect.visibleAtStart = false;
        }

		this.layoutsPanel = new fx.components.Box("layouts");
		
        this.titleLayouts = new fx.components.Text({className : "coverTitle", text : fx.text("Couvertures pour votre album")});
         

		this.classicBox = new fx.components.Box("classicBox");
		this.classicBox.addChild(this.numberPhotoSelect, {width:"210", height: 50, top : 0, left: 75});
		this.classicBox.addChild( new fx.components.Text({className : "label", text : fx.text("Photos")}), {height : 20, top : 15, left : 25});
        this.classicBox.visibleAtStart = false;

		
		this.layoutsPanel.addChild(this.titleLayouts, {width : "100%",height : 20});

        if (this.choicesSelect)
            this.layoutsPanel.addChild(this.choicesSelect, {width:"100%", height: 40, top : 40, left : 0});

        this.layoutsPanel.addChild(this.classicBox, {width:"100%", height:60, top : this.layouts.hasCollectionLayoutsForPage ? 100 : 60});
        this.layoutsPanel.addChild(this.layoutsGrid, {height:"fill", width:"100%", top : 65}); // 120 / 165

		this.addChild(this.layoutsPanel, {width: "100%", height: "100%"});

	}

	/****** Events ******/

	onReady()
	{
		super.onReady();
		
		this.on("changed", this.onTabsChanged, this.numberPhotoSelect);

        if (this.choicesSelect)
		    this.on("tabchanged", this.onChoiceChanged, this.choicesSelect);
        
        this._updateView();
        //this.choicesSelect.selectTab( this.filterChoices.getItemAt(0));
	}

	onTabsChanged()
	{
		this.layoutFilter.search = this.numberPhotoSelect.selectedItem.value;
	}

	onDataEvent(e)
	{
		if (!this.initialized) return;
		
		switch(e.type)
		{
			case "custom-layout-created" :
				this.numberPhotoSelect.selectedIndex = 0;	
				this._newLayoutData = e.data;
				this.delay(this._selectCustomLayouts, 100);
			break;

			// the covers naming where the photos were taken now come first
			case "place-covers-loaded" :
				this.layoutFilter.refresh();
				this.layoutsGrid.forceUpdate();
				this.layoutsGrid.scrollTop();
			break;
		}
	}

    onChoiceChanged(e)
    {
        if (!this.choicesSelect.selectedItem) return;

		this.layoutsGrid.scrollTop();

        let classical = this.choicesSelect.selectedItem.data == "classical";
        this.classicBox.toggle( classical );
        let cover = this._currentArea && this._currentArea.data && this._currentArea.data.isCover;
        this.layoutsGrid.top(cover ? 65 : (classical ? 165 : 110));
        this.layoutFilter.search = classical ? this.numberPhotoSelect.selectedItem.value : "";
    }

    _updateView()
    {
        if (!this.initialized) return;

        if (this._currentArea && this._currentArea.data)
        {
            //this.classicBox.toggle(!this._currentArea.data.isCover)
            
            if (this._currentArea.data.isCover)
            {
                this.layoutFilter.search = "";
                this.titleLayouts.text = fx.text("Couvertures pour votre album");
                this.layoutsGrid.top(65); 
                this.layoutsGrid.maxElementsPerRow = 1;

                if (this.choicesSelect)
                    this.choicesSelect.hide();

                this.classicBox.hide();
                
            }
            else
            {
                this.layoutFilter.search = this.numberPhotoSelect.selectedItem.value;
                this.titleLayouts.text = fx.text("Modèles pour vos pages");
                this.layoutsGrid.top(110); 
                this.layoutsGrid.maxElementsPerRow = 2;

                if (this.choicesSelect)
                {
                    this.choicesSelect.show();
                    this.choicesSelect.selectTab( this.filterChoices.getItemAt(0));
                }
                else
                    this.classicBox.show();
            }
        }

        
        
    }

	_selectCustomLayouts()
	{
		this.delay(this._scrollToNewLayout, 500);
	}
		
	_scrollToNewLayout()
	{
		if (this._newLayoutData)
		{
			let grid = ( !this.currentArea || (this.currentArea.className == "Cover")) ? this.coversGrid : this.layoutsGrid;

			grid.scrollToElement(this._newLayoutData);
			
			this.delay(this._applyEffectNewLayout, 500)
		}
	}

	_applyEffectNewLayout()
	{
		let grid = ( !this.currentArea || (this.currentArea.className == "Cover")) ? this.coversGrid : this.layoutsGrid;
		let element = grid.container.getChildFromData( this._newLayoutData );
		if (element)
			element.addClass("added-animation");

		this._newLayoutData = null;
	}

	// reset scroll to top
	resetScroll()
	{
		this.layoutsGrid.scrollTop();
	}
});
